"use strict";

angular.module("core").service("GroupService", function($http, $state, gettextCatalog, FlashBag, UserService, appConfig) {
    var urlVendor = appConfig.API_SERVER + "/catalog/vendor/community/invite/";
    var urlCustomer = appConfig.API_SERVER + "/catalog/customer/community/invite/";

    function addGroupMembershipFromRegistration(url, token) {
        if (!token) return;

        addGroupMembership(url, token)
        .success(successGroupInviteCallback)
        .error(errorGroupInviteCallback);
    }

    function addGroupMembershipFromLogin(url, token) {
        if (!token) return;

        addGroupMembership(url, token)
        .success(successGroupInviteCallback)
        .error(errorGroupInviteCallback)
        .finally(finallyGroupInviteCallback);
    }

    function addGroupMembership(url, token) {
        return $http({
            method: "POST",
            url: url,
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                groupInvite: token
            })
        });
    }

    function successGroupInviteCallback(data, status) {
        if (status == 201) {
            FlashBag.success(
                gettextCatalog.getString("Welcome to the community of {{groupName}}", {groupName: data.groupName}),
                true
            );
            UserService.refreshCurrentUser();
        }
    }

    function errorGroupInviteCallback(response, status) {
        FlashBag.preformattedWarning(gettextCatalog.getString("Sorry, this group invitation is now closed."), "", true, true);
    }

    function finallyGroupInviteCallback() {
        $state.go("home");
    }

    return {
        addVendorGroupMembershipFromRegistration: function(token) {
            addGroupMembershipFromRegistration(urlVendor, token);
        },
        addVendorGroupMembershipFromLogin: function(token) {
            addGroupMembershipFromLogin(urlVendor, token);
        },
        addCustomerGroupMembershipFromRegistration: function(token) {
            addGroupMembershipFromRegistration(urlCustomer, token);
        },
        addCustomerGroupMembershipFromLogin: function(token) {
            addGroupMembershipFromLogin(urlCustomer, token);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/group/group.service.js
// module id = 423
// module chunks = 0